import { render, staticRenderFns } from "./AnatomiasFisiologiasEditar.vue?vue&type=template&id=6ed476be"
import script from "./AnatomiasFisiologiasEditar.vue?vue&type=script&lang=js"
export * from "./AnatomiasFisiologiasEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports